<template>
  <div class="home">
    <b-navbar id="nav" toggleable="lg" type="light" sticky class="px-xl-5 px-lg-2 m-0">
      <b-navbar-brand href="javascript:void(0);" onclick="window.scroll(0,1);">
        <img alt="Alteris Group logo" :src="require('@/assets/images/ag-logo.svg')">
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse">
        <template #default="{ expanded }">
          <font-awesome-icon v-if="expanded" class="fa-fw" :icon="['fas', 'times']"/>
          <font-awesome-icon v-else class="fa-fw" :icon="['fas', 'bars']"/>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item class="link" href="#learning" v-on:click="setActive">Learning</b-nav-item>
          <b-nav-item class="link" href="#marketing" v-on:click="setActive">Marketing</b-nav-item>
          <b-nav-item class="link" href="#inhouse" v-on:click="setActive">In-House Studios</b-nav-item>
          <b-nav-item class="link" href="#products" v-on:click="setActive">Products</b-nav-item>
          <b-nav-item class="link" href="#contact" v-on:click="setActive">Contact</b-nav-item>
          <b-nav-item class="link" href="#careers" v-on:click="setActive">Careers</b-nav-item>
          <b-nav-item class="link" href="#about" v-on:click="setActive">About Us</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="section">
      <div class="hero-container">

        <img alt="Business woman swiping on a tablet" :src="require('@/assets/images/hero-image.png')">
        <video muted @ended="restartSequence" ref="heroVideo">
          <source :src="require('@/assets/videos/AG-Banner.mp4')" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="hero-overlay">
          <transition name="fade">
            <h3 v-if="showHeroText" id="hero-text-container" ref="heroTextContainer" class="hero-text">{{
                heroText
              }}</h3>
          </transition>
        </div>
      </div>
    </div>
    <div class="section" id="double">
      <div class="section-wrapper bg-grey">
        <h3 class="section-subhead main">Learning and marketing are what we do.<br>Engagement is what we deliver.</h3>
        <div class="container-fluid p-0 mt-5">
          <div class="row" style="margin: auto">
            <div id="learning" style="margin-top: -80px;"></div>
            <div class="col-lg-6 col-md-6 card-deck jumptarget">
              <div class="card-wrapper">
                <h2 class="section-head mb-4">Learning</h2>
                <b-card
                  img-top
                  no-body
                  class="text-left"
                >
                  <div class="image-wrapper" @click="openModal(learningModalId)">
                    <b-card-img :src="require('@/assets/images/learning-img.png')" alt="Business man on video conference"
                                class="rounded-0"></b-card-img>
                    <div class="card-img-filter"></div>
                    <div class="card-play-btn">
                      <font-awesome-icon class="fa-fw" :icon="['fas', 'play']"/>
                    </div>
                  </div>
                  <b-card-body>
                    <b-card-text>
                      When people are engaged, learning is natural. We create engagement using modern learning solutions
                      and the media that drives it. Online. Mobile. Micro. Virtual. Videos. Podcasts. Instructor-led. AR
                      and VR.
                      We work side by side to understand your business and goals. Then we create the experiences, tools
                      and
                      resources that help your team deliver results, on your platforms or ours.
                    </b-card-text>
                  </b-card-body>
                </b-card>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 pt-4 pt-md-0 pt-lg-0 card-deck jumptarget" id="marketing">
              <div class="card-wrapper">
                <h2 class="section-head mb-4">Marketing</h2>
                <b-card
                  no-body
                  img-top
                  class="text-left"
                >
                  <div class="image-wrapper" @click="openModal(marketingModalId)">
                    <b-card-img :src="require('@/assets/images/marketing-img.png')" alt="Team members discussing strategies on a whiteboard"
                                class="rounded-0"></b-card-img>
                    <div class="card-img-filter"></div>
                    <div class="card-play-btn">
                      <font-awesome-icon class="fa-fw" :icon="['fas', 'play']"/>
                    </div>
                  </div>
                  <b-card-body>
                    <b-card-text>
                      We help you talk with your customers. Our creative teams and studios have deep experience in
                      delivering innovative marketing solutions that are on brand and stand out. Whether it’s channel
                      engagement or
                      event marketing, digital, video, virtual or print executions, we’re hands-on and in-house.
                    </b-card-text>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section jumptarget" id="inhouse">
      <div class="section-wrapper mb-5 mb-md-0 mb-lg-0">
        <h2 class="section-head">In-House Studios</h2>
        <p class="mt-3 mx-auto section-caption">Keeping a wealth of resources under one roof has many advantages. We’re
          nimble and can tap into a wealth of talent, technology and equipment at a moment’s notice. It also makes us a
          better value without compromising quality. Ever.</p>

        <swiper ref="agSwiper" :options="swiperOptions">
          <swiper-slide>
            <div style="min-height: 200px;">
              <b-card
                no-body
                class="text-left"
              >
                <b-row>
                  <b-col md="6" class="card-left">
                    <div class="image-wrapper">
                      <b-card-img :src="require('@/assets/images/digital.jpg')" alt="Digital team members reviewing a website on a large monitor"
                                  class="rounded-0"></b-card-img>
                      <div class="card-img-filter"></div>
                      <div class="card-play-btn" @click="openModalBasedOnIndex($event, swiper.realIndex)">
                        <font-awesome-icon class="fa-fw" :icon="['fas', 'play']"/>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="6" class="card-right">
                    <b-card-body class="pt-3 p-md-0">
                      <h2 class="card-heading">Digital</h2>
                      <b-card-text>
                        To arrive at the best digital solutions for your organization, our UX team begins with a
                        discovery
                        phase. Then our development team builds and tests customized web applications and mobile apps,
                        touchscreen experiences, data visualization portals and more. The takeaway – streamlined and
                        intuitive
                        custom user experiences that achieve your goals.
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div style="min-height: 200px;">
              <b-card
                no-body
                class="text-left"
              >
                <b-row>
                  <b-col md="6" class="card-left">
                    <div class="image-wrapper">
                      <b-card-img :src="require('@/assets/images/production.jpg')" alt="Production team on set"
                                  class="rounded-0"></b-card-img>
                      <div class="card-img-filter"></div>
                      <div class="card-play-btn" @click="openModalBasedOnIndex($event, swiper.realIndex)">
                        <font-awesome-icon class="fa-fw" :icon="['fas', 'play']"/>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="6" class="card-right">
                    <b-card-body class="pt-3 p-md-0">
                      <h2 class="card-heading">Full-service Production</h2>
                      <b-card-text>
                        Best practices and product walk-around videos. Podcast series. Executive broadcasts. Livestream
                        events. Even animation. We do it all. While working on your projects, our studio is your studio.
                        And
                        our experienced and passionate staff will turn your project around quickly, while bringing your
                        content to life.
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div style="min-height: 200px;">
              <b-card
                no-body
                class="text-left"
              >
                <b-row>
                  <b-col md="6" class="card-left">
                    <div class="image-wrapper">
                      <b-card-img :src="require('@/assets/images/virtual.jpg')" alt="Screenshot of immersive virtual experience demonstration"
                                  class="rounded-0"></b-card-img>
                      <div class="card-img-filter"></div>
                      <div class="card-play-btn" @click="openModalBasedOnIndex($event, swiper.realIndex)">
                        <font-awesome-icon class="fa-fw" :icon="['fas', 'play']"/>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="6" class="card-right">
                    <b-card-body class="pt-3 p-md-0">
                      <h2 class="card-heading">Virtual</h2>
                      <b-card-text>
                        Virtual is nothing new to us. And as technology evolves, so do our solutions. We design dynamic
                        and
                        immersive virtual experiences that deliver small group collaboration, targeted learning,
                        networking
                        opportunities, large-scale events and expos, and more. Accessing our four in-house studios, the
                        process is seamless and the solutions are always engaging.
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div style="min-height: 200px;">
              <b-card
                no-body
                class="text-left"
              >
                <b-row>
                  <b-col md="6" class="card-left">
                    <div class="image-wrapper">
                      <b-card-img :src="require('@/assets/images/Business-Intelligence.jpg')" alt="Woman working with business data in visually appealing way"
                                  class="rounded-0"></b-card-img>
                      <div class="card-img-filter"></div>
                      <div class="card-play-btn" @click="openModalBasedOnIndex($event, swiper.realIndex)">
                        <font-awesome-icon class="fa-fw" :icon="['fas', 'play']"/>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="6" class="card-right">
                    <b-card-body class="pt-3 p-md-0">
                      <h2 class="card-heading">Business Intelligence</h2>
                      <b-card-text>
                        Data tells stories. Our team analyzes and aggregates your data to reveal fresh insights. Then we
                        create and deliver custom data reports that are visually appealing, intuitive and turnkey. You
                        and
                        your team will benefit from more actionable data and, quite often, all-new stories.
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <!-- If we need navigation buttons -->
          <div class="swiper-button-prev" slot="button-prev">
            <font-awesome-icon class="fa-fw" :icon="['fad', 'chevron-circle-left']"
                               :style="{'--fa-primary-color': '#4d555b', '--fa-secondary-color': '#d8d8d8'}"/>
          </div>
          <div class="swiper-button-next" slot="button-next">
            <font-awesome-icon class="fa-fw" :icon="['fad', 'chevron-circle-right']"
                               :style="{'--fa-primary-color': '#4d555b', '--fa-secondary-color': '#d8d8d8'}"/>
          </div>
        </swiper>
      </div>
    </div>
    <div class="section jumptarget" id="products">
      <div class="section-wrapper bg-grey">
        <h2 class="section-head">Products</h2>
        <p class="mt-3 mx-auto section-caption">Why build every solution from scratch? We offer white label products to
          solve several common business challenges. With each of these platforms, you can quickly brand and create a
          custom fit for your business. Affordably.</p>
        <div class="product-container py-5">
          <div class="container-fluid p-0">
            <div class="row" style="margin: auto">
              <div class="col-lg-6 col-md-6 left">
                <img alt="Covid Comply logo" class="pb-3" :src="require('@/assets/images/covid-logo.png')">
                <p><b>Get back to work safely</b></p>
                <ul>
                  <li>Monitor employee health</li>
                  <li>Track vaccinations*</li>
                  <li>Create operational plans to manage risk</li>
                  <li>Train employees on the basics</li>
                </ul>
                <p>Today, thousands are using COVID-19 Compliance Coach to work in the new normal.</p>
                <span class="asterisk-text">*Local regulations may apply.</span>
                <a class="ag-link pt-4" href="https://covidcomply.com/" target="_blank">Visit Site</a>
              </div>
              <div class="col-lg-6 col-md-6 right">
                <div class="mt-sm-xs-5">

                  <img alt="Covid Compliance Coach phone screen held by woman in mask" :src="require('@/assets/images/covid-img.png')">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-container py-5">
          <div class="container-fluid p-0">
            <div class="row" style="margin: auto">
              <div class="col-lg-6 col-md-6 left">
                <img alt="Better App Builder logo" class="pb-3" :src="require('@/assets/images/bab-logo.png')">
                <p><b>Build a better app in days, not months</b></p>
                <ul>
                  <li>Affordable app design platform</li>
                  <li>Easy-to-use content management system</li>
                  <li>Info mobilization for customers or employees</li>
                  <li>Real-time updating</li>
                  <li>Your brand, zero coding</li>
                </ul>
                <a class="ag-link pt-2" href="https://betterappbuilder.com/" target="_blank">Visit Site</a>
              </div>
              <div class="col-lg-6 col-md-6 right">
                <div class="mt-sm-xs-5">
                  <img alt="Better App Builder screen" :src="require('@/assets/images/bab-img.png')">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-container py-5">
          <div class="container-fluid p-0">
            <div class="row" style="margin: auto">
              <div class="col-lg-6 col-md-6 left">
                <img alt="Learn2Go logo" class="pb-3" :src="require('@/assets/images/l2g-logo.svg')">
                <p><b>Learn anywhere, from any kind of resource</b></p>
                <ul>
                  <li>LMS companion platform with available API integration</li>
                  <li>Designed for apprenticeship learning journeys – interns, mentors, onboarding</li>
                  <li>Learners can submit videos, essays, uploads (and more) to a "Coach" for feedback</li>
                  <li>In-app chat, progress tracking</li>
                </ul>
                <span @click="openModal(l2gModalId)" class="ag-link pt-2">Contact Us</span>
              </div>
              <div class="col-lg-6 col-md-6 right">
                <div class="mt-sm-xs-5">
                  <img alt="Learn2Go phone screen held by hand" :src="require('@/assets/images/l2g-img.png')">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section jumptarget" id="contact">
      <div class="section-wrapper p-0">
        <p class="section-subhead-small pb-5">CONTACT</p>
        <h2 class="section-head">How Can We Help?</h2>
        <div class="mt-3 p-4 mx-auto section-caption">
          <p>Are you looking for a new partnership?</p>
          <p>Or perhaps a different perspective on a specific business challenge?</p>
          <p>Reach out and let us know how we can help.</p>
        </div>
        <button @click="openModal(contactModalId)" class="btn ag-button mt-lg-5 mt-md-3 mt-2">START THE CONVERSATION
        </button>
      </div>
    </div>
    <div class="section jumptarget" id="careers">
      <div class="img-viewport">

        <img alt="Background image of mug with Alteris Group logo" :src="require('@/assets/images/mugshot.png')">
        <div class="img-overlay">
          <p class="section-subhead-small pb-5">CAREERS</p>
          <h2 class="section-head">Join The Team</h2>
          <div class="mt-3 p-4 mx-auto section-caption">
            <p>Are you curious and hardworking? Do you believe two heads are better than one? Are you someone who
              thrives on challenges?</p>
            <p>We are a team of smart and passionate people who care about each other and the work we do. If this
              sounds like you, introduce yourself.</p>
<!--            <button @click="openModal(jobsModalId)" class="jobs-modal-button">Job Postings.</button>-->
          </div>
          <button @click="openModal(careerModalId)" class="btn ag-button mt-lg-5 mt-md-3 mt-2">INTRODUCE YOURSELF
          </button>
        </div>
      </div>
    </div>
    <div class="section jumptarget" id="about">
      <div class="section-wrapper pt-md-0">
        <h2 class="section-head light">About us</h2>
        <p class="mt-3 mx-auto section-caption">Alteris Group opened its doors in 2002 with a handful of people. Today,
          we are more than 100 professionals strong. From our two offices, we collaborate with clients around
          the world to drive engagement and results with every learning and marketing initiative we create.
        </p>
        <div class="container px-0 py-4">
          <div class="row" style="margin: auto">
            <div class="col-lg-4 col-md-4 contact-container">
              <div class="contact-info phone-num">
                <div class="row" style="margin: auto">
                  <div class="col-2">
                    <font-awesome-icon class="fa-fw" :icon="['fas', 'phone']"/>
                  </div>
                  <div class="col text-left">
                    <p><a class="ag-link light" href="tel:248-477-5560">248.477.5560</a></p>
                    <router-link class="ag-link light" to="/privacy-policy">Privacy Policy</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 contact-container">
              <div class="contact-info">
                <div class="row" style="margin: auto">
                  <div class="col-2">
                    <font-awesome-icon class="fa-fw" :icon="['fas', 'map-marker-alt']"/>
                  </div>
                  <div class="col text-left">
                    <p>
                      <a class="ag-link light" href="https://goo.gl/maps/fsty5ELpgNosJTHLA" target="_blank">USA</a>
                    </p>
                  </div>
                </div>
                <div class="row" style="margin: auto">
                  <div class="col-2">
                  </div>
                  <div class="col text-left">
                    <p>26600 Telegraph Rd.</p>
                    <p>Suite 101</p>
                    <p>Southfield, MI 48033</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 contact-container">
              <div class="contact-info">
                <div class="row" style="margin: auto">
                  <div class="col-2">
                    <font-awesome-icon class="fa-fw" :icon="['fas', 'map-marker-alt']"/>
                  </div>
                  <div class="col text-left">
                    <p>
                      <a class="ag-link light" href="https://goo.gl/maps/krXhzGTbw6otLp5k8" target="_blank">Canada</a>
                    </p>
                  </div>
                </div>
                <div class="row" style="margin: auto">
                  <div class="col-2">
                  </div>
                  <div class="col text-left">
                    <p>221B Dougall Ave.</p>
                    <p>Lower Level</p>
                    <p>Windsor, ON N9A 4P3</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row about-logo py-5" style="margin: auto">
            <img alt="Alteris Group logo" :src="require('@/assets/images/ag-logo-lg.svg')">
          </div>
        </div>
      </div>
    </div>

    <videoModal :dataId="learningModalId" :dataSrc="require('@/assets/videos/AG-Learning.mp4')"/>

    <videoModal :dataId="marketingModalId" :dataSrc="require('@/assets/videos/AG-Marketing.mp4')"/>

    <videoModal :dataId="digitalModalId" :dataSrc="require('@/assets/videos/AG-Digital.mp4')"/>

    <videoModal :dataId="virtualModalId" :dataSrc="require('@/assets/videos/AG-Virtual.mp4')"/>

    <videoModal :dataId="productionModalId" :dataSrc="require('@/assets/videos/AG-Production.mp4')"/>

    <videoModal :dataId="businessModalId" :dataSrc="require('@/assets/videos/AG-Business-Intelligence.mp4')"/>

    <formModal :dataId="contactModalId" :dataTitle="contactTitle" :dataTags="[`${environment}-contact`,'website']"
               :dataText="contactText"/>

    <textModal :dataId="jobsModalId" :dataTitle="jobsTitle">
      <div class="jobs-modal-listing-container">
        <div class="jobs-modal-listing-header" v-b-toggle.job-listing-1-collapse>
          <div class="jobs-modal-listing-header-info">
            <p class="section-subhead">Human Resources Manager</p>
            <p>Work Location: <em>26600 Telegraph Rd., Suite 101, Southfield, MI 48033.</em></p>
          </div>
          <span class="jobs-modal-listing-header-icon">
            <font-awesome-icon class="fa-fw when-closed" :icon="['fas', 'chevron-up']" size="lg"/>
            <font-awesome-icon class="fa-fw when-open" :icon="['fas', 'chevron-down']" size="lg"/>
          </span>
        </div>
        <b-collapse id="job-listing-1-collapse" class="mt-2">
          <div class="jobs-modal-listing-body">
            <p><strong>Alteris Group LLC</strong> has an opening for the position of <strong>Human Resources Manager</strong> (Ref# HRM821MC).</p>

            <p class="jobs-modal-listing-body-subheading">Job Duties:</p>
            <ul>
              <li>Establish an HR strategy to lay the foundation of the human resources department corporate-wide.</li>
              <li>Advise management on HR management strategies that align with our organizational mission and values.</li>
              <li>Drive change management by reviewing and assessing the current processes and researching the effectiveness.</li>
              <li>Handle changes from external factors such as employment law changes on a federal and state level.</li>
              <li>Facilitate changes that stem from internal factors such as changes in IT operations due to efficiency, security, or effectiveness needs.</li>
              <li>Establish standardized policies, processes, and procedures for hiring, onboarding, offboarding, performance management, and personnel security processes.</li>
              <li>Develop a hiring process including recruiting and interviewing corporate wide.</li>
              <li>Develop an onboarding process focused on pre- and post-arrival of a new employee.</li>
              <li>Develop an off-boarding process that leads to efficient, smooth, and clear communication among all departments when an employee is leaving the organization.</li>
              <li>Develop a consistent performance management process that focuses on the development of the employee, the team, and the overall organization.</li>
              <li>Develop personnel security processes in collaboration with the IT department to ensure compliance, privacy, and confidentiality.</li>
              <li>Act as a strategic partner to management and advise management on approaches for resolving employee relations issues.</li>
              <li>Implement, present, and facilitate new employee relations policies, processes, and procedures.</li>
              <li>Administer benefits programs, including health, dental, vision, life, short-term, long-term disability insurance, 401k plans, and distribution of all legally required disclosures.</li>
              <li>Serve as a liaison for all employee questions regarding benefits and 401k plans.</li>
              <li>Identify legal requirements and government regulations that affect the organization’s policies and procedures in order to maintain compliance.</li>
              <li>Maintain and rewrite employee handbook clauses.</li>
              <li>Ensure IT compliance regarding accessibility to internal systems to temporary and permanent employees.</li>
              <li>Manage and write contracts for our freelances, LLCs, and other external parties to assure compliance and protect the organization from any liabilities.</li>
              <li>Use of MS Office, MS SharePoint, and HRIS (human resources information systems).</li>
            </ul>

            <p class="jobs-modal-listing-body-subheading">Requirements:</p>
            <ul>
              <li>A Bachelor’s degree or foreign academic equivalent in Human Resources, Communications, or a related field.</li>
              <li>1 year of experience in the job offered or 1 year in a related occupation including HR/Payroll Administrator, Graduate Assistant, or related experience.</li>
              <li>6 months of experience with onboarding and HRIS.</li>
              <li>40hrs/week.</li>
            </ul>

            <p><strong>Application Instructions:</strong> To apply, please MAIL resume to the following address, ensuring to indicate the position reference code <em>(Ref# HRM821MC)</em> for which you are applying.  Mail to:  Alteris Group, LLC, Kevin Movius, CFO, 26600 Telegraph Rd., Suite 101, Southfield, MI  48033.</p>
          </div>
        </b-collapse>
      </div>
    </textModal>

    <formModal :dataId="careerModalId" :dataTitle="careerTitle" :dataTags="[`${environment}-career`,'website']"
               :dataText="careerText"/>

    <formModal :dataId="l2gModalId" :dataTitle="l2gTitle" :dataTags="[`${environment}-learn2go`,'website']"
               :dataText="l2gText"/>

  </div>
</template>

<script>
import videoModal from '@/components/videoModal.vue';
import formModal from '@/components/formModal.vue';
import textModal from '@/components/textModal.vue';

import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export default {
  name: 'Home',
  data() {
    return {
      learningModalId: 'learning-modal',
      marketingModalId: 'marketing-modal',
      digitalModalId: 'digital-modal',
      virtualModalId: 'virtual-modal',
      productionModalId: 'production-modal',
      businessModalId: 'business-modal',
      contactModalId: 'contact-modal',
      jobsModalId: 'jobs-modal',
      careerModalId: 'career-modal',
      l2gModalId: 'l2g-modal',
      contactTitle: 'How can we help?',
      careerTitle: 'Introduce yourself.',
      jobsTitle: 'Job Postings',
      l2gTitle: 'Learn more about Learn2Go.',
      contactText: 'Thanks for your inquiry. Let us know a little about you, and a member of our team will reach out.',
      careerText: 'Send us your contact information and a member of our team will get right back to you.',
      l2gText: 'Thanks for your inquiry. Let us know who you are, and a member of our team will get right back to you.',
      heroText: 'One Company',
      heroTextLoop: ['One Company', 'Two Businesses', 'Three Products', 'Four Studios', 'Infinite Solutions'],
      heroTextCount: 0,
      heroTextChangeDelay: 4200,
      animationDelay: 4200 - 750,
      environment: null,
      heroVideoInterval: null,
      showHeroText: false,
      fadeInAnimationTimer: null,
      fadeOutAnimationTimer: null,
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        centeredSlides: true,
        loop: false,
        threshold: 20,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        breakpoints: {
          0: {
            spaceBetween: 20,
          },
          768: {
            spaceBetween: 30,
          },
          992: {
            spaceBetween: 100,
          },
        }
      }
    };
  },
  components: {
    videoModal,
    formModal,
    textModal
  },
  mounted() {
    if (this.isFirefox() === true) {
      document.body.classList.add("firefox");
    }
    if (this.isIE() === true || this.isSafari() === true) {
      setTimeout(() => {
        this.initialLoad();
      }, 750);
    } else {
      this.initialLoad();
    }
  },
  beforeDestroy() {
    this.reset();
  },
  computed: {
    swiper() {
      return this.$refs.agSwiper.$swiper;
    }
  },
  methods: {
    initialLoad() {
      this.environment = process.env.VUE_APP_ENV;
      if (!this.environment) {
        this.environment = process.env.NODE_ENV;
      }
      document.addEventListener('visibilitychange', this.handleVisibility, false);
      this.restartSequence();
      if (this.$refs.heroVideo) {
        if (this.isIE() === true) {
          this.$refs.heroVideo.addEventListener('loadedmetadata', function() {
            this.$refs.heroVideo.currentTime = 0.25;
          }, false);
        } else {
          this.$refs.heroVideo.currentTime = 0.25;
        }
      }
    },
    reset() {
      this.showHeroText = false;
      // Make sure to stop all animation timeout timers that are to come when we reset
      if (this.fadeInAnimationTimer) {
        clearTimeout(this.fadeInAnimationTimer);
      }
      if (this.fadeOutAnimationTimer) {
        clearTimeout(this.fadeOutAnimationTimer);
      }
      if (this.heroVideoInterval) {
        clearInterval(this.heroVideoInterval);
      }
      this.heroTextCount = 0;
      this.heroText = this.heroTextLoop[0];
      if (this.$refs.heroVideo) {
        this.$refs.heroVideo.currentTime = 0;
        this.$refs.heroVideo.pause();
      }
    },
    /**
     * is the user running the dreaded Internet Explorer
     * @returns {boolean}
     */
    isIE() {
      const ua = window.navigator.userAgent.toLowerCase();
      const isIE = /msie|trident|edge\//.test(ua);
      return isIE;
    },
    /**
     * is the user running Firefox
     * @returns {boolean}
     */
    isFirefox() {
      const isFirefox = typeof InstallTrigger !== 'undefined';
      return isFirefox;
    },
    isSafari() {
      const isSafari = window.safari !== undefined;
      return isSafari;
    },
    /**
     * This event handler is ran when visibility of the page changes, AKA if it's been backgrounded
     */
    handleVisibility() {
      if (document.visibilityState === 'hidden') {
        this.reset();
        // pause animation, video, etc
      } else {
        // restart operation
        this.restartSequence();
      }
    },
    /**
     * This sets up the animation delay because we are non-blocking
     * Duration is in MS
     */
    animation(show = false, duration = 100) {
      let timer = null;
      timer = setTimeout(() => {
        this.showHeroText = show;
      }, duration);
      if (show) {
        this.fadeInAnimationTimer = timer;
      } else {
        this.fadeOutAnimationTimer = timer;
      }
    },
    /**
     * Main method of changing the text in the hero block
     */
    changeHeroText() {
      this.heroText = "";
      this.heroTextCount += 1;
      if (this.heroTextCount >= this.heroTextLoop.length) {
        this.heroTextCount = 0;
      }
      let text = this.heroTextLoop[this.heroTextCount];
      this.heroText = text;
      this.animation(true);
      this.animation(false, this.animationDelay);
    },
    setActive() {
      setTimeout(() => {
        removeHash();
      }, 1);

      function removeHash() {
        history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
      }
    },
    closeAllModals() {
      this.$bvModal.hide(this.learningModalId);
      this.$bvModal.hide(this.marketingModalId);
      this.$bvModal.hide(this.productionModalId);
      this.$bvModal.hide(this.businessModalId);
      this.$bvModal.hide(this.contactModalId);
      this.$bvModal.hide(this.jobsModalId);
      this.$bvModal.hide(this.careerModalId);
      this.$bvModal.hide(this.l2gModalId);
      this.$bvModal.hide(this.digitalModalId);
      this.$bvModal.hide(this.virtualModalId);
      // For IE, removes modal focus
      if (document.activeElement) {
        document.activeElement.blur();
      }
    },
    openModal(modalId) {
      let eventCategory = '';
      this.closeAllModals();
      if (modalId) {
        switch (modalId) {
          case this.learningModalId:
            eventCategory = 'video_launched';
            break;
          case this.marketingModalId:
            eventCategory = 'video_launched';
            break;
          case this.productionModalId:
            eventCategory = 'video_launched';
            break;
          case this.businessModalId:
            eventCategory = 'video_launched';
            break;
          case this.digitalModalId:
            eventCategory = 'video_launched';
            break;
          case this.virtualModalId:
            eventCategory = 'video_launched';
            break;
          default:
            eventCategory = 'form_launched';
            break;
        }
        this.gtag(eventCategory, 'clicked', modalId, null);
        this.$bvModal.show(modalId);
      }
    },
    gtag(category, action, label, value = null) {
      this.$ga.event({
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
      });
    },
    /**
     * Restart the looping sequence
     */
    restartSequence() {
      this.reset();
      // THis is only for the first time around,
      this.heroTextCount = this.heroTextLoop.length;
      this.changeHeroText();
      // this is for first time around in a sequence
      this.heroVideoInterval = setInterval(this.changeHeroText, this.heroTextChangeDelay);
      if (this.$refs.heroVideo) {
        this.$refs.heroVideo.play();
      }
    },
    /**
     * Check slide index and open specified modal
     */
    openModalBasedOnIndex(e, index) {

      if (e.target.classList.contains('fa-primary') || e.target.classList.contains('fa-secondary') || e.target.classList.contains('swiper-pagination-bullet')) {
        e.preventDefault();
        return;
      }

      if (index === 0) {
        this.openModal(this.digitalModalId);
      }
      if (index === 1) {
        this.openModal(this.productionModalId);
      }
      if (index === 2) {
        this.openModal(this.virtualModalId);
      }
      if (index === 3) {
        this.openModal(this.businessModalId);
      }

    }
  }
};
</script>

<style lang="scss">
.home {
  display: flex;
  flex-direction: column;
  min-height: 1px;
}

#double {
  .section-wrapper {
    @media (max-width: 575px) {
      padding: 40px 5px 50px;
    }
  }

  .row {
    justify-content: center;
  }

  .card-deck {
    flex-direction: column;

    &#learning {
      align-items: flex-end;
      scroll-margin-top: 80px;
    }

    &#marketing {
      align-items: flex-start;
      scroll-margin-top: 80px;
    }
  }

  .card-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    .card {
      max-width: 500px;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.24);
      flex-basis: auto;
    }
  }
}

.section {
  @media (max-width: 991px) {
    scroll-margin-top: 60px;
  }
  min-height: 1px;

  .section-wrapper {
    margin: 80px 100px 0;

    &.bg-grey {
      background-color: $bg-grey;
      padding: 50px 100px;
      @media (max-width: 1200px) {
        padding: 50px 75px;
      }
    }

    .section-caption {
      max-width: 1000px;
    }

    @media (max-width: 991px) {
      margin: 40px 40px 0;
      &.bg-grey {
        padding: 40px 50px;
      }
    }
    @media (max-width: 575px) {
      margin: 0;
      padding: 40px 20px 20px;
      &.bg-grey {
        padding: 40px 20px 20px;
      }
    }
  }
}

// Old iOS fix for navbar not being sticky
@supports (-webkit-touch-callout: none) {
  #app {
    margin-top: 60px;

    .navbar {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 999;
    }
  }
}

// IE fix for navbar not being sticky
_:-ms-fullscreen, :root .home {
  margin-top: 60px;

  .navbar {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
  }
}

// Forces IE to jump to proper spot with fixed header
_:-ms-fullscreen, :root .home {
  .jumptarget:target {
    padding-top: 60px;
    margin-top: -60px;
  }
}

.navbar {
  background-color: #fff;
  padding: 0;
  height: 60px;

  .navbar-brand {
    padding: 10px 0;
  }

  .navbar-toggler {
    color: $ag-orange;
    border: none;

    svg {
      font-size: 25px;
    }
  }

  .navbar-collapse {
    height: 100%;
    z-index: 1;

    .navbar-nav {
      height: 100%;

      .nav-item {
        height: 100%;
        @media (min-width: 992px) {
          &:not(:last-of-type) {
            margin-right: 20px;
          }
        }
        @media (min-width: 1200px) {
          &:not(:last-of-type) {
            margin-right: 34px;
          }
        }

        a {
          height: 100%;
          display: flex;
          align-items: flex-end;
          border-bottom: 4px solid #fff;
          padding-bottom: 10px;
          color: $grey-light;
        }

        &.active {
          a {
            color: $ag-orange;
            border-bottom: 4px solid $ag-orange;
            @media (max-width: 992px) {
              color: $grey-light;
              border-bottom: 0;
            }
          }
        }

        &:hover {
          a {
            color: $ag-orange;
            border-bottom: 4px solid $ag-orange;
            @media (max-width: 992px) {
              color: $grey-light;
              border-bottom: 0;
            }
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .navbar-brand {
      padding-left: 12px;
    }
    .navbar-collapse {
      background-color: $ag-orange;
      height: auto;

      .navbar-nav {
        height: auto;
        padding: 15px 0;

        .nav-item {
          height: auto;
          padding: 0 40px;

          a {
            height: auto;
            color: #fff;
            border-bottom: none;
          }

          &.active {
            background-color: $light-orange;

            a {
              color: #fff;
              border-bottom: none;
              font-family: 'Open Sans', sans-serif;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}

.swiper-container {
  background: $grey-dark;
  padding-bottom: 40px;

  .swiper-slide {
    padding: 50px 50px 80px 50px;
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;  -webkit-transform: translate3d(0, 0, 0);

    @media (max-width: 768px) {
      padding: 20px 20px 50px;
    }

    .card {
      background: transparent;

      .card-body {
        padding: 0;
        color: #fff;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        @media (max-width: 768px) {
          bottom: 10px;
        }

        .card-text {
          font-size: 16px;
          line-height: 26px;
          @media (max-width: 768px) {
            line-height: 24px;
          }
        }
      }

      @media (min-width: 1300px) {
        .card-img {
          width: auto;
        }
      }
    }
  }

  .swiper-pagination {
    bottom: 40px;
    @media (max-width: 768px) {
      bottom: 25px;
    }
  }

  .swiper-button-next, .swiper-button-prev {
    top: auto;
    bottom: 30px;

    svg {
      font-size: 45px;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .swiper-button-next {
    right: 35%;

    &:after {
      content: "";
    }
  }

  .swiper-button-prev {
    left: 35%;

    &:after {
      content: "";
    }
  }

  // Adds buttons back in IE11
  _:-ms-fullscreen, .swiper-button-prev, .swiper-button-next {
    svg {
      .fa-primary {
        fill: $grey-dark;
      }

      .fa-secondary {
        fill: rgba(255, 255, 255, 0.5);
      }
    }
  }

  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background-color: rgba(255, 255, 255, 0.4);
    opacity: 1;

    &.swiper-pagination-bullet-active {
      background-color: $ag-orange;
    }
  }
}

#products {
  .product-container {
    .row {
      justify-content: center;
    }

    .left {
      @supports (text-align: center) {
        @media (min-width: 1100px) {
          max-width: 450px;
        }
      }
      text-align: left;

      img {
        width: 100%;
        max-width: 350px;
        @media (min-width: 992px) {
          min-width: 300px;
        }
      }

      ul {
        padding-left: 20px;

        li {
          padding-left: 10px;

          &:not(:last-of-type) {
            padding-bottom: 10px;
          }
        }
      }

      .asterisk-text {
        font-size: 14px;
      }
    }

    // Hacks Products container on IE11 to shrink properly
    _:-ms-fullscreen, :root .left {
      @media (min-width: 1370px) {
        max-width: 450px;
      }
    }

    .right {
      @supports (text-align: center) {
        @media (min-width: 1100px) {
          max-width: 575px;
        }
      }

      img {
        width: 100%;
        max-width: 575px;
      }
    }

    // Hacks Products container on IE11 to shrink properly
    _:-ms-fullscreen, :root .right {
      @media (min-width: 1370px) {
        max-width: 575px;
      }
    }
  }
}

#contact {
  .section-wrapper {
    margin: 0;
    max-width: 1920px;
    height: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    @media (max-width: 991px) {
      height: 500px;
    }
    @media (max-width: 575px) {
      height: 470px;
    }
  }
}

#careers {
  .section-caption {
    width: 100%;
    max-width: 1000px;
  }
}

#about {
  background-color: $grey-dark;
  color: #fff;

  .contact-container {
    display: flex;
    justify-content: center;

    .contact-info {
      max-width: 350px;
      min-width: 280px;

      p {
        margin-bottom: .5rem;
      }

      svg {
        color: $ag-orange;
      }

      .ag-link {
        font-size: 16px;
      }

      &.phone-num {
        // Nasty fix for phone number being out of whack on IE, again due to flexbox
        _:-ms-fullscreen, :root .row {
          @media only screen and (max-width: 991px) and (min-width: 768px) {
            justify-content: center;
          }
        }

        .row {
          // Force IE to ignore justify-content:center until the media query above
          @supports (text-align: center) {
            justify-content: center;
          }
          @media (max-width: 768px) {
            justify-content: flex-start;
          }

          .col {
            max-width: 50%;
            @media (max-width: 768px) {
              max-width: 100%;
            }
          }
        }
      }
    }

    @media (max-width: 768px) {
      &:not(:last-of-type) {
        padding-bottom: 15px;
      }
    }
  }

  .about-logo {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 375px;
      width: 100%;
      @media (max-width: 991px) {
        max-width: 300px
      }
    }
  }
}

.hero-container {
  @extend .img-viewport;

  @media (max-width: 768px) {
    img {
      display: block;
    }
    video {
      display: none;
    }
  }
  @media (min-width: 768px) {
    img {
      display: none;
    }
    video {
      display: block;
    }
  }

  .hero-overlay {
    @extend .img-overlay;
    background: #4d555b;
    opacity: .6;
    transform: translateZ(0);

    .hero-text {
      font-family: 'Open Sans', sans-serif;
      font-weight: 600;
      font-size: 48px;
      color: #fff;
      @media (max-width: 575px) {
        font-size: 24px;
      }
    }

  }
}

//fixes flickering hero banner video in Firefox when transform:translateZ(0) was added to fix flickering in Chrome
.firefox {
  .hero-overlay {
    transform: none;
  }
}

.fade-enter-active, .fade-leave-active {
  opacity: 1;
  visibility: visible;
  transition: all 750ms ease-out;
}

.fade-enter-active {
  animation: fadeIn 750ms;
}

.fade-leave-active {
  animation: fadeIn 750ms reverse;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  visibility: hidden;
}

.fade-enter-to, .fade-leave /* .fade-leave-active below version 2.1.8 */
{
  opacity: 1;
  visibility: visible;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.jobs-modal-button {
  padding: 0;
  margin: 0;
  border: none;
  background-color: unset;
  font-family: inherit;
  font-size: inherit;
  color: $ag-orange;
}
.jobs-modal-listing-container {
  background-color: white;
  color: $grey-dark;
  padding: 24px;
  border-radius: 4px;

  .jobs-modal-listing-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .jobs-modal-listing-header-info {
      p {
        margin-bottom: 0;

        &:first-child {
          text-align: left;
          color: inherit;
        }
      }
    }
    &.not-collapsed .jobs-modal-listing-header-icon .when-open,
    &.collapsed .jobs-modal-listing-header-icon .when-closed {
      display: none;
    }
  }
  .jobs-modal-listing-body {
    border-top: 1px solid $grey-dark;
    padding-top: 24px;
    margin-top: 24px;

    .jobs-modal-listing-body-subheading {
      margin-bottom: 4px;
      font-weight: bold;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }
}
</style>

